import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { getIcon } from '@services/dashboardResource';
import { Td, Row } from '@layout/DashboardTable';
import { Button } from '@atoms';
import { FlexContainer } from '@layout';
import messages from './messages';

const DashboardTableHead = ({ order, sortBy, showTranscripts }) => (
  <thead>
    <Row>
      <Td primary />
      <Td primary>
        <FormattedMessage {...messages.tableHeaderId} />
      </Td>
      <Td primary>
        <FormattedMessage {...messages.tableHeaderOrganization} />
      </Td>
      <Td primary>
        <FormattedMessage {...messages.tableHeaderTitle} />
      </Td>
      <Td primary>
        <FormattedMessage {...messages.tableHeaderDuration} />
      </Td>
      <Td primary>
        <Button invisible name="date" onClick={sortBy} id="sort-list-by-date">
          <FlexContainer inline gap="5px">
            <FormattedMessage {...messages.tableHeaderDate} />
            <img src={getIcon(order, 'date')} />
          </FlexContainer>
        </Button>
      </Td>
      <Td primary>
        <Button
          invisible
          name="creationDate"
          onClick={sortBy}
          id="sort-list-by-creation-date"
        >
          <FlexContainer inline gap="5px">
            <FormattedMessage {...messages.tableHeaderCreationDate} />
            <img src={getIcon(order, 'creationDate')} />
          </FlexContainer>
        </Button>
      </Td>
      <Td primary>
        <Button invisible name="status" onClick={sortBy} id="sort-list-by-status">
          <FlexContainer inline gap="5px">
            <FormattedMessage {...messages.tableHeaderStatus} />
            <img src={getIcon(order, 'status')} />
          </FlexContainer>
        </Button>
      </Td>
      <Td primary>
        <Button invisible name="userId" onClick={sortBy} id="sort-list-by-analyst">
          <FlexContainer inline gap="5px">
            <FormattedMessage {...messages.tableHeaderAnalyst} />
            <img src={getIcon(order, 'userId')} />
          </FlexContainer>
        </Button>
      </Td>
      {showTranscripts ? (
        <Td primary>
          <FormattedMessage {...messages.tableHeaderView} />
        </Td>
      ) : (
        <Td primary>
          <FormattedMessage {...messages.tableHeaderPin} />
        </Td>
      )}
      {!showTranscripts && <Td primary />}
    </Row>
  </thead>
);

DashboardTableHead.propTypes = {
  order: PropTypes.string.isRequired,
  sortBy: PropTypes.func.isRequired,
  showTranscripts: PropTypes.bool,
};

DashboardTableHead.defaultProps = {
  showTranscripts: false,
};

export default DashboardTableHead;



// WEBPACK FOOTER //
// ./components/organisms/DashboardTable/DashboardTableHead.js